import { CreditCardInfo } from "chipply-common";

export default class PaymentInfo {
    public poNumber = "";
    public card = new CreditCardInfo();
}
